import { createActions } from "reduxsauce";

const { Types, Creators } = createActions(
  {
    getLoyaltyDetails: ["pdn"],
    getLoyaltyDetailsLoading: null,
    getLoyaltyDetailsSuccess: ["res"],
    getLoyaltyDetailsFailure: ["error"],

    getLoyaltyActivity: ["pdn"],
    getLoyaltyActivityLoading: null,
    getLoyaltyActivitySuccess: ["res"],
    getLoyaltyActivityFailure: ["error"],

    cleanLoyaltyDetailsState: null,
    cleanLoyaltyPromotionsState: null,

    getLoyaltyConstant: null,
    getLoyaltyConstantLoading: null,
    getLoyaltyConstantSuccess: ["res"],
    getLoyaltyConstantFailure: ["error"],

    redeemRewards: ["data"],
    redeemRewardsLoading: null,
    redeemRewardsSuccess: ["res"],
    redeemRewardsFailure: ["error"],

    redeemRewardsStatusCheck: ["pdn"],
    redeemRewardsStatusCheckLoading: null,
    redeemRewardsStatusCheckSuccess: ["res"],
    redeemRewardsStatusCheckFailure: ["error"],

    getLoyaltyPromotions: ["donorSfid"],
    getLoyaltyPromotionsLoading: null,
    getLoyaltyPromotionsSuccess: ["res"],
    getLoyaltyPromotionsFailure: ["error"],

    activateLoyaltyPromotions: ["donorSfid", "promotionId"],
    activateLoyaltyPromotionsLoading: null,
    activateLoyaltyPromotionsSuccess: ["res", "donorSfid"],
    activateLoyaltyPromotionsFailure: ["error"],

    getLoyaltyGameData: ["donorSfid"],
    getLoyaltyGameDataLoading: null,
    getLoyaltyGameDataSuccess: ["res"],
    getLoyaltyGameDataFailure: ["error"],

    updateLoyaltyGameData: ["donorSfid", "data"],
    updateLoyaltyGameDataLoading: null,
    updateLoyaltyGameDataSuccess: ["res"],
    updateLoyaltyGameDataFailure: ["error"]
  },
  { prefix: "LOYALTY_" }
);
export const LoyaltyDetailsTypes = Types;
export default Creators;
